import script from "./MobileMenuMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenuMain.vue?vue&type=script&setup=true&lang=ts"

import "./MobileMenuMain.vue?vue&type=style&index=0&id=8fb5408a&lang=scss"

const __exports__ = script;

export default __exports__